export default __webpack_public_path__ + "static/media/2389.35c5ef97.png";